"use strict";

exports.__esModule = true;
exports.default = void 0;

var _progress = _interopRequireDefault(require("./progress"));

var _progressBar = _interopRequireDefault(require("./progress-bar"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BProgress: _progress.default,
  BProgressBar: _progressBar.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/progress/index.js
// module id = 540
// module chunks = 7